import { employabilityEntityAdapter, initialState } from '@reducers/orm/employability/employability.state';
import { createReducer, on } from '@ngrx/store';
import { employabilityLoad } from '@reducers/orm/employability/employability.action';

export const employabilityReducer = createReducer(
  initialState,
  on(employabilityLoad, (state, action) => employabilityEntityAdapter.setAll(action.employability, state))
);
